/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ReferentialsResponseDto } from '.././model';

import { apiInstance } from '../../whisApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get all referentials
 */
export const Referentials_findAll = (
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ReferentialsResponseDto>(
    { url: `/api/referentials`, method: 'GET', signal },
    options,
  );
};

export const getReferentialsFindAllQueryKey = () => {
  return ['api', 'referentials'] as const;
};

export const getReferentialsFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof Referentials_findAll>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof Referentials_findAll>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReferentialsFindAllQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Referentials_findAll>>
  > = ({ signal }) => Referentials_findAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Referentials_findAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReferentialsFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof Referentials_findAll>>
>;
export type ReferentialsFindAllQueryError = unknown;

export function useReferentialsFindAll<
  TData = Awaited<ReturnType<typeof Referentials_findAll>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Referentials_findAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Referentials_findAll>>,
          TError,
          Awaited<ReturnType<typeof Referentials_findAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReferentialsFindAll<
  TData = Awaited<ReturnType<typeof Referentials_findAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Referentials_findAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Referentials_findAll>>,
          TError,
          Awaited<ReturnType<typeof Referentials_findAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReferentialsFindAll<
  TData = Awaited<ReturnType<typeof Referentials_findAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Referentials_findAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all referentials
 */

export function useReferentialsFindAll<
  TData = Awaited<ReturnType<typeof Referentials_findAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Referentials_findAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReferentialsFindAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
